module.exports = __webpack_public_path__ + "static/media/手机自助打印.f758e68.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SelfPrinting/手机自助打印.mp4
// module id = 3E0U
// module chunks = 10